import { useEffect } from 'react';
const useEffectOnce = effect => {
  // Purposeful since we don't want exhaustive-deps since its a single execution
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
};
export default useEffectOnce;